import Main from '@/views/administracion/configuracion/catalogos/entidades/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/entidades/Default.vue';

const auth = ['Catálogos:ver'];
const scopes = ['Catálogos:crear', 'Catálogos:editar', 'Catálogos:eliminar'];

const entidades = [
  {
    path: 'entidades',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogoEntidades',
        path: '/',
        meta: {
          title: 'Entidades',
          auth,
          scopes,
        },
        component: Default,
      },
    ],
  },
];

export default entidades;
